export default "__VITE_ASSET__DySZ9Wtn__"